import { createRootRoute } from '@tanstack/react-router';

import { AppShell } from '@/components/layout/AppShell';
import { ErrorBoundary } from '@/components/errors/ErrorBoundary';

export const Route = createRootRoute({
  component: RootComponent,
  errorComponent: ErrorBoundary,
});

/**
 * Root Component
 *
 * Renders AppShell which provides theme, toaster, and the router outlet.
 * Auth gating and workspace resolution are handled by layout routes
 * (_authenticated and _withWorkspace), not here.
 */
function RootComponent() {
  return <AppShell />;
}
